import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhTW from './zh-TW.json'

const resources = {
  'zh-TW': {
    translation: zhTW
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh-TW', // 預設語言
    fallbackLng: 'zh-TW',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
